import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { UserService } from "../services/user.service";

@Injectable({ providedIn: 'root' })
export class SlugResolver implements Resolve<any> {
  constructor(private userService: UserService) {}

  resolve(
    activatedRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    const slug = activatedRoute.paramMap.get('slug')!;;
    return this.userService.getOrgIdBySlug(slug);
  }
}